import { useState } from "react";
import { axiosInstance } from "../services/axiosConfig";
import { BASE_URL, FETCH_CLIENT_DYNAMIC_CONFIG } from "../utility/constants";

const useFetchClientDynamicConfig = () => {
    const [response, setResponse] = useState( null );
    const [error, setError] = useState( null );
    const [isLoading, setIsLoading] = useState( false );

    const FetchClientDynamicConfig = async ( clientId ) => {
        setIsLoading( true );

        try {
            const res = await axiosInstance.get( `${ BASE_URL }${ FETCH_CLIENT_DYNAMIC_CONFIG }${ clientId }/dynamic-config` );
            setResponse( res );
            setError( null );
        } catch ( err ) {
            setError( err );
            console.log( err );
        } finally {
            setIsLoading( false );
        }
    };

    return { response, error, isLoading, FetchClientDynamicConfig };
};

export default useFetchClientDynamicConfig;

